import * as tslib_1 from "tslib";
import React from 'react';
export const FloatingLabelWrapper = ({ state, className, prefix, disabled, children, style, }) => {
    return (React.createElement("div", { className: `flabel${className ? ` ${className}` : ''}${state.isFilled ? ' filled' : ''}${state.hasFocus ? ' on' : ''}${disabled ? ' disabled' : ''}`, "data-prefix": prefix, style: style }, children));
};
export const FloatingLabel = (_a) => {
    var { id, label, icon, children, style, state } = _a, wrapperProps = tslib_1.__rest(_a, ["id", "label", "icon", "children", "style", "state"]);
    return (React.createElement(FloatingLabelWrapper, Object.assign({}, wrapperProps, { state: state, style: style }),
        (!state || !state.isFilled) && (React.createElement("label", { className: "flabel-title", htmlFor: id }, label)),
        React.createElement("div", { className: "flabel-value" }, children),
        icon && React.createElement("div", { className: "flabel-icon" }, icon)));
};
//# sourceMappingURL=FloatingLabel.js.map